module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_02_6NV26_1SA_GSK.2a53f3c7.png";